// Tracking pageData.js
// Page metadata for Empire & Freedom
// CACHE BUST: v1.0.4 - 2025-11-28T00:30:00Z
export const bookInfo = {
  title: "Empire & Freedom",
  subtitle: "A Visual History of India's 350-Year Battle with the Company and the Crown",
  author: "Bhanu Sharma",
  totalPages: 30
};

// Table of contents structure
export const tableOfContents = [
  {
    section: "Front Matter",
    pages: [
      { title: "Cover", page: 1 },
      { title: "Title", page: 2 },
      { title: "Author's Note", page: 3 },
      { title: "Visual Episode Map", page: 4 }
    ]
  },
  {
    section: "East India Company",
    sectionSubtitle: "Company, Conquest & Raj (1600-1858)",
    pages: [
      { title: "1. When the East India Company Reached India", subtitle: "(1600-1613)", page: 5 },
      { title: "2. From Landing to Foothold", subtitle: "(1608-1615)", page: 6 },
      { title: "3. From Surat to Three Presidencies", subtitle: "(1639-1700)", page: 7 },
      { title: "4. Cracks in the Empire: Marathas, Nawabs & Nadir Shah", subtitle: "(1700-1740)", page: 8 },
      { title: "5. From Trade to Power: Plassey, Buxar and the Diwani", subtitle: "(1740-1765)", page: 9 },
      { title: "6. Ruling Bengal: Famine, Hastings and New Laws", subtitle: "(1765-1793)", page: 10 },
      { title: "7. Southward Expansion: Anglo-Mysore Wars and Tipu Sultan", subtitle: "(1767-1799)", page: 11 },
      { title: "8. Breaking the Maratha Confederacy", subtitle: "(1802-1818)", page: 12 },
      { title: "9. Frontier Wars: Sindh, Punjab and the Edge of Empire", subtitle: "(1830-1849)", page: 13 },
      { title: "10. Engines of Rule: Dalhousie, Doctrine of Lapse", subtitle: "(1848-1856)", page: 14 },
      { title: "11. The Fuse is Lit: Awadh, Cartridges and Sepoy Grievances", subtitle: "(1840s-1857)", page: 15 },
      { title: "12. 1857: Rebellion, Siege and the End of Company Rule", subtitle: "(1857-1858)", page: 16 }
    ]
  },
  {
    section: "The Crown",
    sectionSubtitle: "Nationalism, Partition & Freedom (1858-1947)",
    pages: [
      { title: "13. Epilogue: Death of the Company, Birth of the Raj", subtitle: "(1858-1874)", page: 17 },
      { title: "14. Seeds of Nationalism", subtitle: "(1870-1885)", page: 18 },
      { title: "15. Partition & Protest: Swadeshi, Muslim League", subtitle: "(1905-1909)", page: 19 },
      { title: "16. War & Promises: Delhi Durbar, Home Rule", subtitle: "(1911-1919)", page: 20 },
      { title: "17. Massacre & Mahatma: Jallianwala Bagh", subtitle: "(1919-1922)", page: 21 },
      { title: "18. Revolutionary Fire: Bhagat Singh, HSRA", subtitle: "(1926-1931)", page: 22 },
      { title: "19. Salt & Representation: Civil Disobedience", subtitle: "(1930-1934)", page: 23 },
      { title: "20. Ballot & Provinces: GOI Act 1935", subtitle: "(1935-1939)", page: 24 },
      { title: "21. War & Quit India: Bose, INA", subtitle: "(1939-1945)", page: 25 },
      { title: "22. Two Nations?: Lahore Resolution, Cabinet Mission", subtitle: "(1940-1946)", page: 26 },
      { title: "23. Freedom & Partition", subtitle: "(1947-1948)", page: 27 },
      { title: "24. Recap: A 350-Year Journey", subtitle: "", page: 28 }
    ]
  },
  {
    section: "Back Matter",
    pages: [
      { title: "Tagore Poem", page: 29 },
      { title: "About the Author", page: 30 }
    ]
  }
];

// Image URLs from Notion database (High-Res Image column)
// Database: https://www.notion.so/makerco/b83f9d107a3c47509a16fdd45d33ca78
// Note: These are temporary AWS URLs and will expire after ~1 hour
// 📦 Source AWS S3 URLs - Fallback for development
// All 30 pages - Permanent, publicly accessible
const sourceImageUrls = {
  1: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/rrqhclq1pks7yvy4sps2m3h3/messages/cover-image-2-kqbbr62suvc.jpg',
  2: 'https://bikhra.s3.eu-north-1.amazonaws.com/Page%2002_Title.png',
  3: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/rrqhclq1pks7yvy4sps2m3h3/messages/titleimage-3-w6f0qp7e4f.jpg',
  4: 'https://bikhra.s3.eu-north-1.amazonaws.com/Page%2005_Index.png',
  5: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-06-8hr8rhdl0w3.jpg',
  6: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-07-4q85099ah7.jpg',
  7: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-08-fqtxguy188h.jpg',
  8: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-09-i7ltysvnuyi.jpg',
  9: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-10-f2avqts1r3w.jpg',
  10: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-11-zdxaw7lxaw9.jpg',
  11: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-12-4k7gjeh81hg.jpg',
  12: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-13-yn2jfaalxe.jpg',
  13: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-14-gpp1kgdmlu.jpg',
  14: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-15-e8id4b1fteu.jpg',
  15: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-16-u9vyfvg9gf.jpg',
  16: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-17-uw5w4lw0o3b.jpg',
  17: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-18-6nfrx6r1bwt.jpg',
  18: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-19-c68s9lkldxs.jpg',
  19: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-20-u2psa6f03cd.jpg',
  20: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-21-kvies449hk.jpg',
  21: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-22-x9bx9ojbitk.jpg',
  22: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-23-2ym9nhi4a7u.jpg',
  23: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-24-ln12b5mszwe.jpg',
  24: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-25-1md7wobil4q.jpg',
  25: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-26-bvq2hrx5z5d.jpg',
  26: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-27-074w7uhay7qo.jpg',
  27: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-28-us69ns0cn6m.jpg',
  28: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/page-29-t6pehffjiu.jpg',
  29: 'https://bikhra.s3.eu-north-1.amazonaws.com/25.png',
  30: 'https://bikhra.s3.eu-north-1.amazonaws.com/26.png'
};

// 🖼️ Active Image URLs - Using direct AWS S3 for now
// Note: Cloudinary fetch requires public bucket access or whitelisting
// Using direct S3 URLs ensures immediate functionality
const imageUrls = sourceImageUrls;

// Generate page image URL with Cloudinary optimization
// Updated: 2025-11-26 - Using Cloudinary with height-based optimization
// All 31 pages served from permanent S3 storage via Cloudinary
export function getPageImageUrl(pageNumber, height = null) {
  // Check if we have an image URL for this page
  if (imageUrls && imageUrls[pageNumber]) {
    const sourceUrl = imageUrls[pageNumber];
    
    // Direct S3 URLs work perfectly and don't get blocked with 400 errors
    return sourceUrl;
  }
  
  // Fallback to placeholder for pages without images yet
  const paddedNumber = String(pageNumber).padStart(2, '0');
  return `https://via.placeholder.com/1200x1600/f5f3f0/2a2825?text=Page+${paddedNumber}`;
}

// Get chapter info for a specific page
export const getChapterForPage = (pageNumber) => {
  for (const section of tableOfContents) {
    const page = section.pages.find(p => p.page === pageNumber);
    if (page) {
      return {
        ...page,
        section: section.section,
        sectionSubtitle: section.sectionSubtitle
      };
    }
  }
  return null;
};
